import { colours } from "@shared/ui.design-system";

export const scrollBarCss = {
  "::-webkit-scrollbar": {
    height: "4px"
  },
  "::-webkit-scrollbar-track": {
    background: "transparent"
  },
  "::-webkit-scrollbar-thumb": {
    backgroundColor: colours.accent.strong,
    borderRadius: "2px",
    border: "2px solid onratechange"
  }
};
